import { FormattedMessage } from "react-intl";

import { LOGOUT_URI } from "@citrine/client/utils";
import { useConfiguration } from "@citrine/resources/configuration";

import { CancelButton, SubmitButton } from "#src/components/form";

import * as sx from "./index.sx";

export const TermsModal = ({
  accept,
  open,
}: {
  accept: () => void;
  open: boolean;
}) => {
  const trialTermsUrl = useConfiguration("trialTermsUrl");

  return (
    <sx.Dialog
      id="terms-modal"
      initialValues={open ? {} : undefined}
      onSubmit={accept}
      title={<FormattedMessage id="Agree to Terms" />}
      actions={
        <>
          <CancelButton href={LOGOUT_URI}>
            <FormattedMessage id="Log Out" />
          </CancelButton>
          <SubmitButton>
            <FormattedMessage id="Agree" />
          </SubmitButton>
        </>
      }
    >
      <span>
        <FormattedMessage
          id="Terms Message"
          values={{
            privacyLink: (text: string[]) => (
              <a
                href="https://citrine.io/privacy-policy/"
                target="_blank"
                rel="noreferrer"
              >
                {text}
              </a>
            ),
            trialLink: trialTermsUrl
              ? (text: string[]) => (
                  <a href={trialTermsUrl} target="_blank" rel="noreferrer">
                    {text}
                  </a>
                )
              : "_",
          }}
        />
      </span>
    </sx.Dialog>
  );
};
